// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const baseEnvironment = {
  production: false,
  apiUrl: 'http://210.2.73.100:82',
  appId: {
    root: 'D84927C4-E682-EA11-80CF-97CC0449692F',
    app: '52A932A2-6B6E-EA11-80CF-97CC0449692F'
  },
  map: {
    bienDong: {
      osm: '',
      hybrid: ''
    },
    printService: '',
    geometryService: '',
    arcgisUrl: '',
    center: [],
    scale: 0,
    phuongXaUrl: '',
    maQuanHuyen: '',
    maPhuongXa: ''
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
